export default [
  {
    path: '/report',
    name: 'report-view',
    component: () => import('@/views/report/reportView.vue'),
    props: true,
    meta: {
      resource: 'Report',
      action: 'manage',
    },
  },
  {
    path: '/report-visualization',
    name: 'report-visualization',
    component: () => import('@/views/report/report-charts/ReportChartsView.vue'),
    props: true,
    meta: {
      resource: 'Report',
      action: 'manage',
    },
  },
  {
    path: '/profitability-reports',
    name: 'profitability-reports-view',
    component: () => import('@/views/report/profitabilityReportsView.vue'),
    meta: {
      resource: 'Report',
      action: 'manage',
    },
  },
  {
    path: '/pre-built-reports',
    name: 'pre-built-reports-view',
    component: () => import('@/views/report/preBuiltReports.vue'),
    meta: {
      resource: 'Report',
      action: 'read',
    },
  },
  {
    path: '/report-export',
    name: 'report-export-view',
    component: () => import('@/views/report/export/reportExportView.vue'),
    meta: {
      resource: 'Report',
      action: 'manage',
    },
  },
  {
    path: '/pl-report-structure',
    name: 'profitAndLossReportStructure',
    component: () => import('@/views/report/plReportStructureView.vue'),
    meta: {
      resource: 'Report',
      action: 'manage',
    },
  },
  {
    path: '/multiple-dimension',
    name: 'multiple-dimension-view',
    component: () => import('@/views/report/multipleDimensionView.vue'),
    meta: {
      resource: 'Report',
      action: 'manage',
    },
  },
  {
    path: '/ai-report',
    name: 'ai-report-view',
    component: () => import('@/views/ai-report/ai-report-chat.vue'),
    meta: {
      resource: 'Report-AI',
      action: 'manage',
    },
  }
]
